<template>
    <!--begin::Dashboard-->
    <div class="row">
        <div class="col-lg-2 aos-init aos-animate text-center d-none d-lg-block mx-auto resume-content" data-aos="fade-right fade-left" data-aos-delay="100" >
          <div class="card resume-content float-right">
            <div class="card-header" v-show="client.nombreEmpresa!=''"><div class="tarjeta-perfil"></div></div>
            <div class="card-body">
              <div class="card-text" v-show="client.nombreEmpresa!=''">
                <span>Nombre Empresa</span> <p class="text-truncate">{{client.nombreEmpresa}}</p>
              </div>
              <div class="card-text" v-show="client.nombreEmpresa!=''">
                <span>RUT empresa</span> <p>{{client.rutEmpresa}}-{{client.rutEmpresaDv}}</p>
              </div>
              <div class="card-text">
                <span>Correo Corporativo</span> <p class="text-truncate">{{client.email}}</p>
              </div>
             <div class="card-text">
                <span class="text-primary">Total Pagos</span> <h4 class="mt-1">{{totalPagos|currency}}</h4>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-9 aos-init aos-animate content d-flex flex-column mt-1 mb-5 mx-auto" data-aos="fade-up" data-aos-delay="100">
          <h3>Historial de Pagos</h3>
          <h2>búsqueda de pagos anteriores</h2>
          <div class="card card-row d-flex flex-row mb-4">
            <b-form action="" class="d-search d-flex justify-content-between align-items-end row" @submit.stop.prevent="onSubmit">
              <div class="form-group col-sm-12 col-lg-3 mb-1 mt-1">
                <label for="startDate">Fecha Desde</label>  
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  max-width="290"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="computedDateFormattedMomentjs"
                      clearable
                      class="form-control"
                      placeholder="dd/mm/aaaa"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      @click:clear="desde = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="desde"
                    @change="menu1 = false"
                    locale="es-cl"
                     :first-day-of-week="1"
                  ></v-date-picker>
                </v-menu>
              </div>
              <div class="form-group col-sm-12 col-lg-3 mb-1 mt-1">
                <label for="endDate"></label>  
                <label for="startDate">Fecha Hasta</label>  
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  max-width="290"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="computedDateFormattedMomentjs2"
                      clearable
                      class="form-control"
                      placeholder="dd/mm/aaaa"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      @click:clear="hasta = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="hasta"
                    @change="menu2 = false"
                    locale="es-cl"
                     :first-day-of-week="1"
                  ></v-date-picker>
                </v-menu>
              </div>

              <!-- <div class="form-group col-sm-12 col-lg-3 mb-1 mt-1"> 
                <label for="rutPagador">Rut Pagador (Sin digito)</label>  
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  max-width="290"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="rutPagador"
                      clearable
                      class="form-control"
                      placeholder="11111111"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                 
                </v-menu>
              </div> -->
              <div class="form-group col-sm-12 col-lg-3 mb-1 mt-1">
                <label for="inputSucursal">Rut Pagador (Sin digito)</label>  

                  <b-form-input  v-model="empresa" placeholder="11111111"></b-form-input>
              </div>

           <div class="form-group col-sm-12 col-lg-3 mb-1 mt-1">
                <label for="inputSucursal">Banco Receptor</label>  
                <b-form-select v-model="bancoSeleccionado" :options="bancos" value-field="codigoMedioPago"
                  text-field="codigoMedioPago" class="custom-select text-capitalize">
                  <option value="" class="text-capitalize">Todos</option>
                  </b-form-select>
              </div>

               <div class="form-group col-sm-12 col-lg-3 mb-1 mt-1">
                <label for="inputSucursal">Orden ID</label>  

                  <b-form-input  v-model="ordenId" placeholder="12345"></b-form-input>
              </div>

               <div class="form-group col-sm-12 col-lg-3 mb-1 mt-1">
                <label for="inputSucursal">Tipo Documento</label>  
                <b-form-select v-model="tipoDocumentoSeleccionado" :options="tipoDocumentos" value-field="codigoTipoDocumento"
                  text-field="codigoTipoDocumento" class="custom-select text-capitalize">
                  <option value="" class="text-capitalize">Todos</option>
                  </b-form-select>
              </div>
               <div class="form-group col-sm-12 col-lg-3 mb-1 mt-1">
                <label for="inputSucursal">Tipo Documento</label>  
                <b-form-select v-model="empresaSeleccionada" value-field="codigoEmpresa"
                  text-field="codigoEmpresa" class="custom-select text-capitalize">
                  <option value="" class="text-capitalize">Todos</option>
                  <option value="MUNICH" class="text-capitalize">MUNICH</option>
                  <option value="PROV" class="text-capitalize">PROVEFARMA</option>
                  <option value="SVM" class="text-capitalize">SOCOFAR</option>
                  </b-form-select>
              </div>
<!--               
              <div class="form-group col-sm-12 col-lg-3 mb-1 mt-1">
                <label for="inputSucursal">Cliente</label>  
                <b-form-select v-model="empresa" :options="empresas" value-field="codigoEmpresa"
                  text-field="nombreEmpresa" class="custom-select">
                  <option value="">Todas</option>
                  </b-form-select>
              </div> -->
              
              <button class="btn btn-outline-primary ml-auto mt-3" ref="kt_login_signin_submit"> buscar </button>
            </b-form>
          </div>
          <h2>Pagos anteriores</h2>
          <div class="row">
              <div class="col-3"></div>
          <div class="col-9">
          <!-- <download-excel 
          class="download"
            :data="orders"
            :fields="json_fields"
            worksheet="Pagos"
            name="Pagos.xls">
           <i class="far fa-file-excel"></i> Descargar
          </download-excel> -->
      
         <button v-on:click.prevent="getCsvDetalle" class="download ml-5"><i class="far fa-file-excel"></i> Descargar Detalle </button>
            <button v-on:click.prevent="getCsv" class="download"><i class="far fa-file-excel"></i> Descargar Cabecera </button>
    
                                           
                       
          </div></div>

          <b-overlay :show="loading" varant="white" rounded="sm">
          <div class="accordion" id="accordionExample">
              <v-expansion-panels class="card-row d-flex flex-row flex-md-column">
                <v-expansion-panel v-for="(item,i) in visiblePages" :key="i">
                    <v-expansion-panel-header>
                        <div class="card-row d-flex flex-row flex-md-column " id="headingOne">
                            <div class="d-flex justify-content-between align-items-center row">
                            <div class="form-group mb-1 mt-1">
                                <label for="inputFn">Orden Id</label>
                                <span id="inputFn" class="justify-content-center text-center">{{item.ordenId}}</span>
                            </div>
                            <div class="form-group mb-1 mt-1">
                                <label for="inputFn">Empresa Receptora</label>
                                <span id="inputFn" class="justify-content-center text-center">{{item.codigoEmpresa}}</span>
                            </div>

                            <div class="form-group mb-1 mt-1">
                                <label for="inputFn">Fecha</label>
                                <span id="inputFn" class="justify-content-center text-center">{{item.fechaPago | formatDate}}</span>
                            </div>

                             <div class="form-group mb-1 mt-1">
                                <label for="inputFn">Hora</label>
                                <span id="inputFn" class="justify-content-center text-center">{{item.fechaPago | formatTime}}</span>
                            </div>

                             <div class="form-group  mb-1 mt-1 text-center">
                                <label for="inputLocale" class="justify-content-center text-center">Rut</label>
                                <span class="justify-content-center text-center">{{item.rutEmpresa}}-{{item.dvEmpresa.toUpperCase()}}</span>
                            </div>

                              <div class="form-group  mb-1 mt-1 text-center">
                                <label for="inputLocale" class="justify-content-center text-center">R. Social</label>
                                <span id="inputLocale" class="justify-content-center text-center">{{item.nombreEmpresa}}</span>
                            </div>

                            <div class="form-group mb-1 mt-1">
                                <label for="inputMount" class="justify-content-end text-right">Banco Pagador</label>
                                <span class="justify-content-center text-center">{{item.codigoMedioPago.toUpperCase()}}</span>
                            </div>
                            <div class="form-group mb-1 mt-1" v-if="item.esAbono">
                                <label for="inputMount" class="justify-content-end text-right">Monto Pagado</label>
                                <span id="inputMount" class="justify-content-end text-right">{{item.monto | currency}}</span>
                            </div>
                            <div v-else class="form-group mb-1 mt-1">
                                <label for="inputMount" class="justify-content-end text-right">Monto Pagado</label>
                                <span id="inputMount" class="justify-content-end text-right">{{item.montoOriginal | currency}}</span>
                            </div>
<!-- 
                            <div class="form-group mb-1 mt-1">
                                <label for="inputDateLast">Metodo Recibo Ebso</label>
                                <span id="inputDateLast" class="justify-content-center text-center">{{item.metodoReciboEbso}}</span>
                            </div>

                             <div class="form-group mb-1 mt-1">
                                <label for="inputDateLast">Nº Recibo Ebso</label>
                                <span id="inputDateLast" class="justify-content-center text-center">{{item.numeroRecibo}}</span>
                            </div> -->

                             <div class="form-group mb-1 mt-1">
                                <label for="inputFn">Fecha Recibo (Ebso)</label>
                                <span id="inputFn" class="justify-content-center text-center">{{item.fechaContable}}</span>
                            </div>

                            <div class="form-group mb-1 mt-1">
                                <label for="inputFn">Tipo Pago</label>
                                <span id="inputFn" class="justify-content-center text-center">{{item.tipoOrden}}</span>
                            </div>

                             <div class="form-group mb-1 mt-1">
                                <label for="inputFn">Origen</label>
                                <span id="inputFn" class="justify-content-center text-center">{{item.origen}}</span>
                            </div>

                            <!-- <div class="form-group  mb-1 mt-1 text-center">
                                <label for="inputLocale" class="justify-content-center text-center">Cliente</label>
                                <span id="inputLocale" class="justify-content-center text-center">{{item.nombreEmpresa}}</span>
                                <span class="d-block justify-content-center text-center">{{item.rutEmpresa}}-{{item.dvEmpresa.toUpperCase()}}</span>
                            </div>
                            <div class="form-group mb-1 mt-1">
                                <label for="inputMount" class="justify-content-end text-right">monto pagado</label>
                                <span id="inputMount" class="justify-content-end text-right">{{item.monto | currency}}</span>
                                <span>BANCO: {{item.codigoMedioPago.toUpperCase()}}</span>
                            </div> -->
                            <div class="buttons-icon mb-1 mt-1">
                                <a href="#;" v-on:click.prevent="getVoucher(item)"><i class="far fa-envelope text-primary"></i></a>
                                <a href="#;" v-on:click.prevent="getPdf(item)"><i class="far fa-file-pdf text-primary"></i></a>                               
                            </div>
                            </div>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="card-body">
                            <template>
                              <div class="w-200px mb-1 mt-1">
                                  <label for="inputFn">Recibo Nº</label>
                                  <span id="inputFn">{{item.numeroRecibo}}</span>
                              </div>
                            <div v-if="item.esAbono" class="d-flex justify-content-between align-items-left">
                                 <span id="inputFn">{{item.observaciones}}</span>
                            </div>
                            <div v-for="(itemDetalle,i) in item.detalles.filter(item => item!=null && (item.esRecibo==false))" :key="'detail'+i" class="item-separator">
                            <div v-if="itemDetalle.esRecibo" class="d-flex justify-content-between">
                              <div class="mr-2"  data-toggle="tooltip" data-placement="top" title="Vendida"><i class="fa fa-check-circle text-success"></i></div>
                              <div class="w-200px mb-1 mt-1">
                                  <label for="inputFn">Recibo Nº</label>
                                  <span id="inputFn">{{itemDetalle.numeroDocumento}}</span>
                              </div>
                              
                               <div class="w-200px mb-1 mt-1">
                                  <label for="inputFn">Tipo Documento</label>
                                  <span id="inputFn">{{itemDetalle.tipoDocumento}}</span>
                              </div>
                              <div class="w-200px mb-1 mt-1">
                                <label for="inputDateLast">--</label>
                                <span id="inputDateLast" class="justify-content-center text-center">{{itemDetalle.reciboEbso}}</span>
                              </div>
                              <div class="w-15 mb-1 mt-1">
                                  <label for="inputDateLast">Vence</label>
                                  <!-- <span id="inputDateLast" class="_text-success">{{itemDetalle.fechaVencimiento | formatDate}}</span> -->
                                  <span id="inputDateLast" class="_text-success">{{itemDetalle.fechaVencimiento | formatDate}}</span>
                              </div>
                              <div class="w-15 mb-1 mt-1">
                                  <label for="inputLocale">sucursal</label>
                                  <span id="inputLocale">{{item.nombreSucursal}}</span>
                              </div>
                              <div class="w-15 mb-1 mt-1">
                                  <label for="inputMount" class="justify-content-end text-right">montos</label>
                                  <span id="inputMount" class="justify-content-end text-right">{{itemDetalle.montoDocumento | currency}}</span>
                                  <div class="w-15 mb-1 mt-1">
                                        <label for="inputCredited" class="justify-content-end text-right">utilizado</label>
                                        <span id="inputCredited" class="justify-content-end text-right">- {{itemDetalle.deuda | currency}}</span>
                                    </div>
                                    <div class="w-15 mb-1 mt-1 text-right">
                                        <label for="inputCredited" class="justify-content-end text-right">saldo</label>
                                        <span id="inputCredited" class="justify-content-end text-right">{{itemDetalle.montoDocumento - itemDetalle.deuda | currency}}</span>
                                    </div>

                              </div>
                              <div class="w-15 mb-1 mt-1 text-right">
                                &nbsp;
                              </div>
                            </div>
                            <div v-else class="d-flex justify-content-between">
                              <div class="mr-2" data-toggle="tooltip" data-placement="top" title="Vendida">
                                <i class="fa fa-check-circle text-success"></i>
                              </div>
                              <div class="w-200px mb-1 mt-1">
                                  <label for="inputFn">Documento Nº</label>
                                  <span id="inputFn">{{itemDetalle.numeroDocumento}}</span>
                              </div>
                               <div class="w-200px mb-1 mt-1">
                                  <label for="inputFn">Tipo Documento</label>
                                  <span id="inputFn">{{itemDetalle.tipoDocumento}}</span>
                              </div>
                              <div class="w-200px mb-1 mt-1">
                                <label for="inputDateLast">Nº Recibo Ebso</label>
                                <span id="inputDateLast" class="justify-content-center text-center">{{itemDetalle.reciboEbso}}</span>
                              </div>
                              <div class="w-15 mb-1 mt-1">
                                  <label for="inputDateLast">Vence</label>
                                  <!-- <span id="inputDateLast" class="_text-success">{{itemDetalle.fechaVencimiento | formatDate}}</span> -->
                                  <span id="inputDateLast" class="_text-success">{{itemDetalle.fechaVencimiento | formatDate}}</span>
                              </div>
                              <div class="w-15 mb-1 mt-1">
                                  <label for="inputLocale">sucursal</label>
                                  <span id="inputLocale">{{item.nombreSucursal}}</span>
                              </div>
                              <!--div class="w-15 mb-1 mt-1">
                                  <label for="inputMount" class="justify-content-end text-right">monto total</label>
                                  <span id="inputMount" class="justify-content-end text-right">{{itemDetalle.montoDocumento | currency}}</span>
                              </div-->
                              <div class="w-15 mb-1 mt-1">
                                  <label for="inputCredited" class="justify-content-end text-right">monto pagado</label>
                                  <span id="inputCredited" class="justify-content-end text-right">{{itemDetalle.montoAsignado | currency}}</span>
                              </div>
                              <!--div class="w-15 mb-1 mt-1 text-right">
                                  <label for="inputCredited" class="justify-content-end text-right">monto pendiente</label>
                                  <span id="inputCredited" class="justify-content-end text-right">{{itemDetalle.saldo | currency}}</span>
                              </div-->
                              <div class="w-15 mb-1 mt-1 text-right">
                                  <span v-show="itemDetalle.codigoTipoDocumento == 'INV' || itemDetalle.codigoTipoDocumento == 'CM' || itemDetalle.codigoTipoDocumento == 'DM'" id="inputCredited" class="justify-content-end text-right" v-on:click="getPdfFactura(itemDetalle)"><i class="far fa-file-pdf text-danger cursor-pointer"></i></span>
                              </div>
                            </div>

                            </div>
                            </template>
                          </div>
			
                    </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
          	
		  </div>
          </b-overlay>
           <v-pagination
              v-model="page"
              :length="Math.ceil(orders.length/perPage)"
            ></v-pagination>
        <b-modal ref="my-modal" id="bv-modal-example" hide-footer>
        <template v-slot:modal-title>
          Enviar Documento PDF a Correo
        </template>
        <div class="d-block text-center">
            <div class="col-md-12 aos-init aos-animate content d-flex flex-column mt-1 mb-5 mx-auto" data-aos="fade-up" data-aos-delay="100">
           <div class="row card card-row d-flex flex-row mb-4">
              
              <div class="col-2 text-center p-0">
                <img src="/media/img/email.svg" alt="">
              </div>
              <div class="col-10">
                <div class="d-flex flex-row justify-content-between align-items-center row">
                  <div class="form-group col-sm-12 mb-1 mt-1">
                    <label for="">enviar una copia del comprobante a:</label>
                    <input type="email" v-model="email" placeholder="correo@empresa.cl" class="form-control">
                  </div>
                  <button type="button" v-on:click.prevent="sendVoucher()" class="btn btn-outline-secondary px-5 mx-2" desabled="">ENVIAR</button>
                  
                </div>
              </div>
            </div>
            </div>
        </div>
        <b-button class="btn btn-outline-secondary px-5 mx-2" @click="$bvModal.hide('bv-modal-example')">Cerrar</b-button>
      </b-modal>
          <!--<nav aria-label="Page navigation example" class="d-flex flex-row justify-content-center mt-4">
			  <ul class="pagination">
			    <li class="page-item">
			      <a class="page-link" href="#" aria-label="Previous">
			        <span aria-hidden="true">&laquo;</span>
			      </a>
			    </li>
			    <li class="page-item"><a class="page-link" href="#">1</a></li>
			    <li class="page-item"><a class="page-link" href="#">2</a></li>
			    <li class="page-item"><a class="page-link" href="#">3</a></li>
			    <li class="page-item">
			      <a class="page-link" href="#" aria-label="Next">
			        <span aria-hidden="true">&raquo;</span>
			      </a>
			    </li>
			  </ul>
			</nav>-->
        
        </div>
      </div>
    <!--end::Dashboard-->
</template>


<script>

import { mapState } from "vuex";
import { GET_ORDER, GET_PDF, SEND_PDF, GET_ORDERS_HISTORY,GET_ORDERS_HISTORY_EXCEL,GET_ORDERS_HISTORY_EXCEL_DETALLE,GET_PDF_FACTURA} from "@/core/services/store/payment.module";
import { GET_CONVERSIONBANCOS } from "@/core/services/store/conversionBanco.module";
import { GET_TIPO_DOCUMENTOS } from "@/core/services/store/tipoDocumento.module";
//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
//import {Money} from 'v-money'
import { validationMixin } from "vuelidate";
import {
  minLength
} from "vuelidate/lib/validators";

import moment from 'moment'
moment.locale( 'es' );

export default {
  mixins: [validationMixin],
  name: "history",
  components: {},
  data() {
    return {
      page: 1,
      perPage: 10,
      loading:true,
      menu2:false,
      menu1:false,
      email:"",
      currentItem:null,
      hasta: moment().format("YYYY-MM-DD"),
      desde:moment().add(-2, 'days').format("YYYY-MM-DD"),
      // desde:moment().add(-56, 'months').format("YYYY-MM-DD"),
      empresa:'',
      // rutPagador:'',
      totalPagos:0,
      orders_exports:[],
      form: {
        documento: "",
        desde: "",
        hasta: ""
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$ ',
        suffix: '',
        precision: 0,
        masked: false
      },
      json_fields: {
        "Empresa Receptora": "codigoEmpresa",
        "Fecha": "fechaPagoFormateada",
        "Hora": "fechaPagoHora",
        "Rut": "rutEmpresa",
        "R. Social": "nombreEmpresa",
        "Banco Pagador": "codigoMedioPago",
        "Monto Pagado": "monto",
        // "Metodo Recibo Ebso": "metodoReciboEbso", //oculto hasta que veamos de donde se saca ese campo
        "Nº Recibo Ebsos": "numeroReciboExcel",
        // "Nº Recibo Ebso": {
        //   field: 'numeroReciboExcel',
        //   callback:(value) =>{
        //     return `${value}` 
        //   }
        // },
        "Fecha Recibo Ebso": "fechaContable", 
        "Tipo Pago": "tipoOrden", 
        "Origen":"origen"

        // "Nº Comprobante": "numeroTransaccion",
        // "MontoPagado": "monto",
        // "Cliente": "nombreEmpresa",
        // "Rut": "rutEmpresaCompleto",
        // "FechaPago": "fechaPago",
        // "Banco": "codigoMedioPago"
      },
      bancos: null,
      bancoSeleccionado: "",
      tipoDocumentoSeleccionado: "",
      empresaSeleccionada: "",
      ordenId: "",
      tipoDocumentos:[]
    };
  },
  validations: {
    form: {
      documento: {
        minLength: minLength(3)
      },
      desde: {
        
      },
      hasta: {

      }
    }
  },
  mounted () {
    const documento= null;
    // const rutPagador= null;
    const empresa= null;
    // this.getOrdersHistory({ params: { documento, rutPagador, desde:this.desde, hasta:this.hasta }});
    this.getOrdersHistory({ params: { documento, empresa, desde:this.desde, hasta:this.hasta, banco: this.bancoSeleccionado,ordenId : this.ordenId,codigoTipoDocumento: this.tipoDocumentoSeleccionado, codigEmpresa: this.empresaSeleccionada }});

    this.getBancos()
    this.getTipoDocumentos();
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        documento: null,
        empresa: null,
        desde: moment().format("YYYY-MM-DD"),
        hasta: moment().add(-1, 'weeks').format("YYYY-MM-DD")
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      const documento = this.$v.form.documento.$model;
      const empresa = this.empresa;
      const desde = this.desde;
      const hasta = this.hasta;
      const banco = this.bancoSeleccionado;
      const ordenId = this.ordenId;
      const codigoTipoDocumento = this.tipoDocumentoSeleccionado 
      const codigoEmpresa = this.empresaSeleccionada 
      // const rutPagador = this.rutPagador;

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        // dummy delay
        setTimeout(() => {
          // send login request
          this.getOrdersHistory({ params: { documento, empresa, desde, hasta,banco,ordenId,codigoTipoDocumento,codigoEmpresa }});
          // this.getOrdersHistory({ params: { documento, rutPagador, desde, hasta }});
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        }, 500);
    },
     getBancos() {
      this.$Progress.start();
   
        this.$store
          .dispatch(GET_CONVERSIONBANCOS)
          .then((response) => {
            this.bancos = response, 
            this.loading=false
          });
    
    },
     getTipoDocumentos() {
      this.$Progress.start();
   
        this.$store
          .dispatch(GET_TIPO_DOCUMENTOS)
          .then((response) => {
            this.tipoDocumentos = response, 
            this.loading=false
          });
    
    },
     getPdfFactura(item) {
      this.$Progress.start();
   
        this.$store
          .dispatch(GET_PDF_FACTURA,item)
          .then((response) => {
           if(response.codigo == 0)
            { 
              window.open(response.mensaje,'_blank')
            }else{
 this.$bvToast.toast(`Documento no encontrado.`, {
        title: 'Error Documento',
        autoHideDelay: 5000,
        variant: "danger",
        toaster:"b-toaster-top-right",
        appendToast: true
      })
            }
            this.loading=false
          });
    
    },
    descargarPdfFactura(url){
      const link = document.createElement('a')
      link.target = '_blank'
      link.href = url;
      link.download = 'documento.pdf'
      document.body.appendChild(link)
      link.click();
      document.body.removeChild(link)
    },
    getOrdersHistory(params = null) {
      this.$Progress.start();
      setTimeout(() => {
        this.$store
          .dispatch(GET_ORDERS_HISTORY, params)
          .then((response) => {
            this.$Progress.finish(), 
            this.totalPagos = response.totalPagos, 
            this.loading=false            
          });
      }, 500);
    },
    getOrder() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_ORDER, this.$route.query.codigo)
          .then((response)=>{this.order = response,this.$Progress.finish()});
    },
    getDescriptor(item){
      let descriptor = item.cantidadDocumentos;
      if(item.esAbono){
        descriptor = "Abono";
      }
      return descriptor;
    },
    getVoucher(item){
      this.currentItem = item;
      // console.log(item);
      this.$refs['my-modal'].show();
    },
    sendVoucher() {
      const t = this;
      this.$Progress.start();
      this.$store
          .dispatch(SEND_PDF, {tokenOrden : this.currentItem.tokenOrden, email : this.email})
          .then(function(){
            t.$Progress.finish()
            t.$refs['my-modal'].hide();
          });
    },
    getPdf(item) {
      const t = this;
      this.$Progress.start();
      this.$store
          .dispatch(GET_PDF, item.tokenOrden)
          .then(function(response){
            t.document = response;
            t.$Progress.finish()
            setTimeout(function()
              {
                // console.log(t.document.data);
                var blob = new Blob([t.document], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.setAttribute('href', URL)
                link.href = url;
                
                link.setAttribute("download", "comprobante.pdf");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }, 0);
          });
    },
    getExcel() {
   
  

    var documento = this.$v.form.documento.$model;
      const empresa = this.empresa;


      const params =  { documento, empresa, desde:this.desde, hasta:this.hasta, banco: this.bancoSeleccionado, ordenId: this.ordenId,codigoTipoDocumento: this.tipoDocumentoSeleccionado };

      this.$store
          .dispatch(GET_ORDERS_HISTORY_EXCEL, {params,responseType: 'blob'})
          .then(function(response){
        
                var blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.setAttribute('href', URL)
                link.href = url;
                
                link.setAttribute("download", "Pagos.xlsx");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
         
          });
    },
    getCsv() {
   

    var documento = this.$v.form.documento.$model;
      const empresa = this.empresa;


      const params =  { documento, empresa, desde:this.desde, hasta:this.hasta, banco: this.bancoSeleccionado, ordenId: this.ordenId,codigoTipoDocumento: this.tipoDocumentoSeleccionado, codigoEmpresa: this.empresaSeleccionada };
    
      this.$store
          .dispatch(GET_ORDERS_HISTORY_EXCEL, {params,responseType: 'blob'})
          .then(function(response){
        
                var blob = new Blob([response], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.setAttribute('href', URL)
                link.href = url;
                
                link.setAttribute("download", "Pagos.csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
         
          });
    },
    getCsvDetalle() {
   

    var documento = this.$v.form.documento.$model;
      const empresa = this.empresa;


      const params =  { documento, empresa, desde:this.desde, hasta:this.hasta, banco: this.bancoSeleccionado, ordenId: this.ordenId,codigoTipoDocumento: this.tipoDocumentoSeleccionado, codigoEmpresa: this.empresaSeleccionada };
    
      this.$store
          .dispatch(GET_ORDERS_HISTORY_EXCEL_DETALLE, {params,responseType: 'blob'})
          .then(function(response){
        
                var blob = new Blob([response], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.setAttribute('href', URL)
                link.href = url;
                
                link.setAttribute("download", "PagosDetalle.csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
         
          });
    },
  },

  filters:{
    formatDate(value) {
        const duration = moment(value).format('DD/MM/yyyy');
        return `${duration}`;
    },
    formatTime(value) {
        const hora = moment(value).format('HH:mm:ss');
        return `${hora}`;
    }
  },
  computed: {
    visiblePages () {
      return this.orders.slice((this.page - 1)* this.perPage, this.page* this.perPage)
    },
    ...mapState({
      orders : state => state.payment.orders.ordenesPago,
      sucursales : state => state.payment.orders.sucursales,
      empresas : state => state.payment.orders.empresas,
      errors: state => state.errors,
      client: state => state.auth.user,
      rutCliente: function(){
        return `${this.order.rutEmpresa}-${this.order.dvEmpresa}`;
      },  
      computedDateFormattedMomentjs () {
        return this.desde ? moment(this.desde).format('DD/MM/yyyy') : ''
      },
      computedDateFormattedMomentjs2 () {
        return this.hasta ? moment(this.hasta).format('DD/MM/yyyy') : ''
      }
    }),
    
  }
};
</script>
<style>
.w-15 {width:15%;}
.w-100px {width:100px;}
.w-200px {width:150px;}
.b-form-datepicker {min-width:130px;}
.b-form-datepicker label {
        padding-bottom: 3px !important;
    padding-top: 6px;
    text-transform: none;
    white-space: nowrap !important;
    font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
    padding: 10px 5px;
}
.d-content-full{width:100%;}

.v-expansion-panel-header {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-size: 0.9375rem;
    line-height: 1;
    /* min-height: 48px; */
    outline: none;
    padding: 0px 24px !important;
    position: relative;
    -webkit-transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
}
.theme--light.v-expansion-panels .v-expansion-panel {
    background-color: #FFFFFF;
    border-radius: 10px !important;
    margin: 0 0 5px 0 !important;
    color: rgba(0, 0, 0, 0.87);
}
.item-separator {
    padding-bottom: 1em;
    margin-bottom: 1rem;
    border-bottom: 1px solid rgba(0,0,0,0.1);
}

.item-separator:last-child {
    padding-bottom: 0;
    margin-bottom: 0;
    border-bottom: 0px solid rgba(0,0,0,0.1);
}
.download {cursor:pointer; text-align:right; margin-right:10px;display: table-cell; float:right !important;}
</style>
